<template>
  <b-modal
    v-model="showModal"
    title="Keret hozzáadása"
    ok-title="Hozzáadás"
    ok-variant="success"
    cancel-title="Mégsem"
    size="lg"
    :ok-disabled="!isValid"
    @ok="save"
  >
    <b-form-group
      :state="errors$validity_start.length > 0 ? false : null"
      :invalid-feedback="errors$validity_start"
    >
      <label for="validityStart">Kezdő időpont</label>
      <b-form-datepicker
        id="validityStart"
        v-model="validityStart"
        v-bind="datePickerLabels"
        :date-disabled-fn="validityStartDisabled"
        :state="errors$validity_start.length > 0 ? false : null"
        locale="hu-HU"
        required
      ></b-form-datepicker>
    </b-form-group>
    <b-form-group
      :state="errors$validity_end.length > 0 ? false : null"
      :invalid-feedback="errors$validity_end"
    >
      <label for="toDate">Záró időpont</label>
      <b-input-group>
        <b-form-datepicker
          id="validityEnd"
          v-model="validityEnd"
          v-bind="datePickerLabels"
          :date-disabled-fn="validityEndDisabled"
          :state="errors$validity_end.length > 0 ? false : null"
          locale="hu-HU"
          :disabled="validityEnd.length === 0"
        ></b-form-datepicker>
        <b-input-group-append>
          <b-button @click="validityEnd = ''" variant="danger" size="sm"><i class="fas fa-trash"></i></b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <pool-limitations-editor v-model="limitations" />
  </b-modal>
</template>
<script>
import moment from 'moment'
import datePickerLabels from '../common/_datePickerLabels'
import { mysqlFormatDate } from '../../utils/Date'

import FormValidation from '../../utils/mixins/FormValidation'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

import poolLimitations from './_poolLimitations'
import PoolLimitationsEditor from './partials/PoolLimitationsEditor'

export default {
  mixins: [
    FormValidation(['validity_start', 'validity_end']),
    ErrorHandler()
  ],
  components: {
    'pool-limitations-editor': PoolLimitationsEditor
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      datePickerLabels,
      showModal: false,
      validityStart: '',
      validityEnd: '',
      limitations: poolLimitations,
    }
  },
  computed: {
    dateState() {
      return this.validityStart !== ''
    },
    isValid() {
      return this.dateState
    },
    lastDayOfThisMonth() {
      return moment().date(1).add(1, 'months').subtract(1, 'days')
    },
    lastDayOfLastMonth() {
      return moment().date(1).subtract(1, 'days')
    }
  },
  watch: {
    showModal: function(show) {
      this.$emit('update:show', show)
    },
    show: function(show) {
      if(show) {
        this.reset()
      }

      this.showModal = show
    },
    validityStart(start) {
      this.validityEnd = this.getLastDayOfMonth(start).format(moment.HTML5_FMT.DATE)
    }
  },
  mounted() {
    this.$on('toggle', this.toggleModal)
    this.showModal = this.show
  },
  methods: {
    isLastDayOfMonth(date) {
      var lastDay = this.getLastDayOfMonth(date)
      return date.date() === lastDay.date()
    },
    getLastDayOfMonth(date) {
      return moment(date).date(1).add(1, 'months').subtract(1, 'days')
    },
    toggleModal() {
      this.showModal = !this.showModal
    },
    reset() {
      this.validityStart = ''
      this.clearErrors()
    },
    save(modal) {
      modal.preventDefault()
      this.clearErrors()

      this.$http.post(this.$url('api.billing-pools.store'), {
        customer_id: this.customerId,
        validity_start: mysqlFormatDate(this.validityStart),
        validity_end: mysqlFormatDate(this.validityEnd),
        limitations: this.limitations
      })
      .then(({data}) => {
        this.showModal = false

        this.$root.$emit('add-pool', {...data})
      })
      .catch(this.handleErrors)
    },
    validityStartDisabled(date) {
      var current = moment(date)
      if(current.date() !== 1) {
        return true
      }

      return this.lastDayOfLastMonth.isAfter(current)
    },
    validityEndDisabled(date) {
      var current = moment(date)
      var from = moment(this.validityStart)

      if(!current.isAfter(from) || !this.isLastDayOfMonth(current)) {
        return true
      }

      return false
    }
  }
}
</script>